module.exports = __webpack_public_path__ + "static/media/1021001BE.dea6bf56.jpg";